export default {
  props: {},
  components: {},
  data() {
    return {};
  },
  computed: {
    styles() {
      if (this.isApple || !this.isApp) {
        return {};
      }
      const statusBarHeight = window.cfmoto.statusBarHeight();
      return {
        paddingTop: `${statusBarHeight}`
      };
    }
  },
  methods: {},
  created() {},
  mounted() {},
  beforeUnmount() {},
  watch: {}
};